/** Tiny helpers for video URLs — YouTube + Vimeo + uploaded MP4. */

const YT_RE =
  /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/i;

export function youtubeId(url: string | null | undefined): string | null {
  if (!url) return null;
  const m = url.match(YT_RE);
  return m?.[1] ?? null;
}

export function youtubeEmbed(url: string | null | undefined): string | null {
  const id = youtubeId(url);
  return id ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0` : null;
}

export function youtubeThumb(url: string | null | undefined): string | null {
  const id = youtubeId(url);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
}

const VIMEO_RE = /vimeo\.com\/(\d+)/i;

export function isVimeo(url: string | null | undefined): boolean {
  return !!url && VIMEO_RE.test(url);
}

export function vimeoEmbed(url: string | null | undefined): string | null {
  if (!url) return null;
  const m = url.match(VIMEO_RE);
  return m ? `https://player.vimeo.com/video/${m[1]}?autoplay=1` : null;
}

/** A URL that points to an uploaded asset (e.g. Supabase storage) rather than a 3p service. */
export function isUploadedVideo(url: string | null | undefined): boolean {
  if (!url) return false;
  return /\.(mp4|webm|mov|m4v)(\?|$)/i.test(url);
}
